import styled from "styled-components";

export const Container = styled.div`
    padding: 14px;
    margin-bottom:10px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #e377e6;
    border-radius: 4px;
    box-shadow: 0 6px 20px 0 rgba(0,0,0,0.1);
`;